<template>
  <v-dialog
    :value="value"
    max-width="600"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title>パーミッショングループの作成</v-card-title>

      <v-card-text>
        <v-text-field
          v-model="groupName"
          label="グループ名"
          outlined
          dense
          :error-messages="nameError"
        />

        <div class="subtitle-1 mb-2">
          権限の選択
        </div>
        <v-divider class="mb-3" />

        <div
          v-for="permission in sortedPermissions"
          :key="permission.id"
        >
          <v-checkbox
            v-model="selectedPermissionIds"
            :value="permission.id"
            :label="`${getSubjectLabel(permission.subject)} : ${permission.action}`"
            dense
            hide-details
            class="mt-1"
          />
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="close"
        >
          キャンセル
        </v-btn>
        <v-btn
          color="primary"
          :loading="isCreating"
          :disabled="!groupName || selectedPermissionIds.length === 0"
          @click="create"
        >
          作成
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, computed } from '@vue/composition-api'

export default {
  name: 'CreateGroupDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    permissions: {
      type: Array,
      required: true,
    },
    subjectLabels: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const groupName = ref('')
    const selectedPermissionIds = ref([])
    const nameError = ref('')
    const isCreating = ref(false)

    const getSubjectLabel = subject => props.subjectLabels[subject] || subject

    const sortedPermissions = computed(() => [...props.permissions].sort((a, b) => {
      const labelA = getSubjectLabel(a.subject)
      const labelB = getSubjectLabel(b.subject)

      return labelA.localeCompare(labelB, 'ja')
    }))

    const close = () => {
      groupName.value = ''
      selectedPermissionIds.value = []
      nameError.value = ''
      emit('input', false)
    }

    const create = async () => {
      if (!groupName.value) {
        nameError.value = 'グループ名を入力してください'

        return
      }

      isCreating.value = true
      emit('create', {
        name: groupName.value,
        permissionIds: selectedPermissionIds.value,
      })
      isCreating.value = false
      close()
    }

    return {
      groupName,
      selectedPermissionIds,
      nameError,
      isCreating,
      sortedPermissions,
      getSubjectLabel,
      close,
      create,
    }
  },
}
</script>
